import {ColumnSettings} from './ColumnSettings';
import {RowSettings} from './RowSettings';

export class Tab
{
    public readonly id:string;
    public readonly workbookId:string;
    public readonly name:string;
    public readonly cols:number;
    public readonly rows:number;
    public readonly columnNames:string[];
    public readonly columnSettings:ColumnSettings[];
    public readonly rowSettings:RowSettings[];
    public readonly slots:any;
    public readonly slotLocationToSlot:any;
    public readonly slotLocationToStyle:any;
    public readonly slotLocationToFormat:any;

    constructor(json:any)
    {
        this.id = json['id'];
        this.workbookId = json['workbookId'];
        this.name = json['name'];
        this.cols = json['cols'];
        this.rows = json['rows'];
        this.columnNames = [];
        for( let i = 0, length = (json['columnNames'] || []).length; i < length; i++ )
        {
            this.columnNames.push(json['columnNames'][i]);
        }
        this.columnSettings = [];
        for( let i = 0, length = (json['columnSettings'] || []).length; i < length; i++ )
        {
            this.columnSettings.push(new ColumnSettings(json['columnSettings'][i]));
        }
        this.rowSettings = [];
        for( let i = 0, length = (json['rowSettings'] || []).length; i < length; i++ )
        {
            this.rowSettings.push(new RowSettings(json['rowSettings'][i]));
        }
        this.slots = json['slots'];
        this.slotLocationToSlot = json['slotLocationToSlot'];
        this.slotLocationToStyle = json['slotLocationToStyle'];
        this.slotLocationToFormat = json['slotLocationToFormat'];
    }
}
